package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.ui.component.datetime.util.DateTimeUtil
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import com.wintermar.inspection.graphql.type.InspectionStatus
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.onEach

class CompleteInspectionUseCase(
    private val inspectionRepository: InspectionRepository,
) {
    operator fun invoke(
        inspectionId: String
    ): Flow<FlowResult<Pair<InspectionStatus, String>>> {
        return inspectionRepository.completeInspection(inspectionId).onEach { result ->
            if (result is FlowResult.Success) {
                val status = result.data?.first ?: InspectionStatus.UNKNOWN__
                val lastUpdated = result.data?.second ?: DateTimeUtil.getCurrentDateIsoUtc0()

                inspectionRepository.updateStatus(
                    inspectionId = inspectionId,
                    status = status,
                    lastUpdated = lastUpdated
                )
            }
        }
    }
}
